export default {
    jwt: 'jwt.dong.wxapp-admin',
    currentUser: 'currentUser.dong.wxapp-admin',
    adminSideMenus: 'adminSideMenus.dong.wxapp-admin',
    mchSideMenus: 'mchSideMenus.dong.wxapp-admin',
    tabs: 'tabs.dong.wxapp-admin',
    showAmount: 'showAmount.dong.wxapp-admin'
}



// WEBPACK FOOTER //
// ./src/config/cache_keys.js